import React from 'react';

function Links() {
  return (
    <ul>
      <li>
        <a href="/resources/">Explore our resources and support content</a>
      </li>
      <li>
        <a href="/contact-us/ask-va">Contact us online through Ask VA</a>
      </li>
      <li>
        <a href="/resources/helpful-va-phone-numbers/">
          Call us at one of our helpful VA phone numbers
        </a>
      </li>
    </ul>
  );
}

export default function BetaTestingUpdated() {
  return (
    <>
      <h2>We're currently in beta testing</h2>
      <p>
        We're still building the bot's ability to respond to your questions.
        There may be many questions the bot can't answer yet.
      </p>
      <h2>What's coming next</h2>
      <p>Here's what we're working on:</p>
      <ul>
        <li>
          Smarter learning over time (ongoing). We may use AI technology to help
          improve the chatbot's answers and make its responses more accurate and
          helpful.
        </li>
        <li>
          Personalized experiences (later this year). You'll be able to sign in
          to start getting a more personalized experience.
        </li>
        <li>
          Live agent support (later this year). For select topics, you'll be
          able to connect directly with a real person, a first step toward
          broader live support.
        </li>
        <li>
          More places to find the chatbot (later this year). We're bringing the
          chatbot to more pages across VA.gov, so help is there when you need
          it.
        </li>
      </ul>
      <p>
        We're committed to making the chatbot more useful over time, while
        keeping it secure and accessible for every Veteran, including those who
        use assistive technologies.
      </p>
      <p>
        If you have questions about VA benefits and services that our chatbot
        can't answer right now, you can get the information in any of these
        ways:
      </p>
      <Links />
    </>
  );
}
